<ll-titulo>Editar usuario #{{ usuarioId }}</ll-titulo>
<ll-toolnavbar>
    <cuentas-admin-toolnavbar [displayButtons]="'all'"></cuentas-admin-toolnavbar>
</ll-toolnavbar>

<cuentas-edit [usuarioId]="usuarioId"></cuentas-edit>
